<div class="content">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="page-title-box">
                    <div class="page-title-right">
                        <ng-container *ngIf="admission">
                            <button *ngIf="!admission.isDischarged" (click)="openModifyModel(templateAdd)" class="btn btn-primary btn-sm">
                                <i class="mdi mdi-note-plus-outline mr-1"></i>Add New Vitals
                            </button>
                        </ng-container>
                        <!--<a href="javascript:;" class="btn btn-secondary btn-sm ml-1" (click)="onBack()">
                            <span><i class="fe-arrow-left mr-1"></i> Back</span>
                        </a>-->
                    </div>
                    <h4 class="page-title">Doctor Vitals</h4>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6 mb-4" *ngFor="let item of records; let i = index;">
                <div class="table-responsive-lg">
                    <table class="table table-centered table-sm table-striped table-bordered mb-0 bg-white">
                        <tbody>
                            <ng-container *ngIf="loading">
                                <tr>
                                    <td colspan="8">
                                        <span class="mr-1 spinner-grow spinner-grow-sm"></span> Please wait while loading doctor Vitals ...
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="!loading && !records.length">
                                <tr>
                                    <td colspan="8">
                                        <i class="mdi mdi-alert text-warning mr-1"></i> Doctor Vitals does not exists.
                                    </td>
                                </tr>
                            </ng-container>
                            <ng-container *ngIf="!loading && records.length">
                                <ng-container>
                                    <tr>
                                        <td [textContent]="(i + 1)"></td>
                                        <td>
                                            <a href="javascript:;" title="Edit" (click)="openModifyModel(templateAdd, item)"><i class="mdi mdi-file-document-edit-outline mr-1"></i></a>
                                            <a href="javascript:;" title="Delete" (click)="delete(item)"><i class="mdi mdi-trash-can-outline"></i></a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Created Date</td>
                                        <td [textContent]="item.createdDate | date:'dd-MM-yyyy, hh:mm a'"></td>
                                    </tr>
                                    <tr>
                                        <td>Created By</td>
                                        <!--<td [textContent]="item.createdByName"></td>-->
                                        <td>
                                            <span [textContent]="item.createdByName"></span> <b> ( </b> <span [textContent]="item.createdByRole"></span><b> ) </b>
                                        </td>
                                    </tr>
                                    <tr *ngIf="item.modifiedDate">
                                        <td>Modified Date</td>
                                        <td [textContent]="item.modifiedDate  | date:'dd-MM-yyyy, hh:mm a' "></td>
                                    </tr>
                                    <tr *ngIf="item.modifiedByName">
                                        <td>Modified By</td>
                                        <!--<td [textContent]="item.modifiedByName || '-----'"></td>-->
                                        <td>
                                            <span [textContent]="item.modifiedByName || '-----'"></span> <b> ( </b> <span [textContent]="item.modifiedByRole"></span><b> ) </b>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td><b style="justify-content: center">Vital Name </b></td>
                                        <td><b style="justify-content: center">Vital Value & Ranges</b></td>
                                    </tr>
                                    <tr *ngFor="let subItem of item.vitals">
                                        <td [textContent]="subItem.name"></td>
                                        <td>
                                            <span [textContent]="(subItem.givenValue || 0)"><b>  </b></span><span [textContent]="subItem.unitType"></span> <b>  &  </b>
                                            <span [textContent]="(subItem.min)"></span> to <span [textContent]="(subItem.max)"></span>
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #templateAdd>

    <div class="modal-header">
        <h4 class="modal-title">
            <i class="mdi mdi-note-plus-outline mr-1"></i>
            <span *ngIf="!selected">Add</span>
            <span *ngIf="selected">Update</span>
            Vitals
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="onCloseModal();">×</button>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="form-group position-relative mb-0">
                            <label>Date <span class="text-danger">* <!--<span *ngIf="selected" class="font-italic">(read-only)</span>--></span></label>
                            <input class="form-control date-picker" type="text" block
                                   [(ngModel)]="todayDate" [minDate]="minDate"
                                   autocomplete="nope" placeholder="Select date"
                                   [ngClass]="{ 'is-invalid': submitted && form.date.errors }"
                                   ngbDatepicker #date="ngbDatepicker"
                                   (click)="date.toggle(); $event.stopPropagation();"
                                    [value]="todayDate | date: 'dd/MM/yyyy'"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12 mt-2" *ngIf="!isVitalTypeloading && vitalTypes.length > 0">
                <table class="table table-centered table-nowrap table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th>Vital Type</th>
                            <th>Value</th>
                            <th>Unit</th>
                            <th>Ranges</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of vitalTypes;let i = index;">
                            <td>
                                <span [textContent]="item.name"></span>
                            </td>
                            <td>
                                <input class="form-control" type="text" numbersOnly maxlength="3" [(ngModel)]="item.givenValue" placeholder="Enter measured value." />
                            </td>
                            <td>
                                <span [textContent]="item.unitType"></span>
                            </td>
                            <td>
                                <span [textContent]="item.min"></span> <b>-</b><span [textContent]="item.max"></span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button type="button" class="btn btn-light btn-sm mr-1" (click)="onCloseModal();">Cancel</button>
        <button type="submit" (click)="modify()" class="btn btn-primary btn-sm">
            <span *ngIf="submitting"><span class="spinner-grow spinner-grow-sm mr-1"></span> please wait ...</span>
            <span *ngIf="!submitting"><i class="fe-plus mr-1" placement="right"></i>Submit</span>
        </button>
    </div>
</ng-template>
